/**
 * 角色用户模块接口
 * name：接口名称
 * url：接口api
 * method：接口请求方法，默认GET
 * defaultParams：默认参数
 */

export default [
  // 获取指定组织下角色基本信息列表 groupId
  {
    name: 'getRoleList',
    url: '/api/aam/v1/mgmt/group/{@}/roles'
  },
  // 新增角色  groupId->hierachyId=0
  {
    name: 'addRole',
    url: '/api/aam/v1/mgmt/group/{@}/0/roles',
    method: 'POST'
  },
  // 修改角色  hierachyId->roleId
  {
    name: 'putRole',
    url: '/api/aam/v1/mgmt/group/{@}/{@}/roles/{@}', // groupId, hierachyId, roleId
    // url: '/api/aam/v1/mgmt/role-hierachy/{@}/roles/{@}',
    method: 'PUT'
  },
  // 删除角色 hierachyId->roleId
  {
    name: 'delRole',
    url: '/api/aam/v1/mgmt/role-hierachy/{@}/roles/{@}',
    method: 'DELETE'
  },
  // 获取角色详情 - 组数据,回显组织数据
  {
    name: 'getRoleDetail',
    url: '/api/aam/v1/mgmt/roles/{@}/role-group' // roleId
  },
  // 获取组织下所有用户
  {
    name: 'getUser',
    url: '/api/aam/v1/mgmt/groups/government/{@}/tree-members'
  },
  // 获取当前组织下无角色用户
  {
    name: 'getWithoutUser',
    url: '/api/aam/v1/mgmt/users/{@}/without-role'
  },
  // 设置该角色下的用户,或者设置该用户下的角色 userID 废弃
  // {
  //   name: "setRole",
  //   url: "/api/aam/v1/mgmt/users/roles-batch",
  //   method: "PUT"
  // },
  // 设置该角色下的用户
  {
    name: 'setRole2',
    // url: '/api/aam/v1/mgmt/roles/users-coverage',
    url: '/api/aam/v1/mgmt/roles/groups/users-coverage',
    method: 'PUT'
  },
  //清空该角色下的用户
  {
    name: 'clearRole2',
    // url: '/api/aam/v1/mgmt/roles/{@}',
    url: '/api/aam/v1/mgmt/roles/groups/users-coverage?clearUserRoleIds={@}',
    method: 'PUT'
  },
  //设置该用户下的角色
  {
    name: 'setRole1',
    url: '/api/aam/v1/mgmt/users/roles-coverage',
    method: 'PUT'
  },
  //清空该用户下的角色
  {
    name: 'clearRole',
    url: '/api/aam/v1/mgmt/users/{@}',
    method: 'PUT'
  },
  // 获取指定角色的用户列表 hierachyId->roleId
  {
    name: 'getRoleUser',
    url: '/api/aam/v1/mgmt/role-hierachy/{@}/roles/{@}/users'
  },
  // 角色绑定权限码 hierachyId->roleId
  {
    name: 'setRoleCodes',
    url: '/api/aam/v1/mgmt/role-hierachy/{@}/roles/{@}/resources',
    method: 'PUT'
  },
  // 获取对应角色权限码 hierachyId->roleId
  {
    name: 'getRoleCodes',
    url: '/api/aam/v1/mgmt/role-hierachy/{@}/roles/{@}/resources'
  },
  // 获取当前用户权限码
  {
    name: 'getPermissionCodes',
    url: '/api/aam/v1/portal/user/resource'
  },
  // 获取角色管理指定组织 groupId
  {
    name: 'getOrganTree',
    url: '/api/aam/v1/portal/user/scope/groups/tree/{@}'
  },
  // 选择指定组织获取指定部门数据 groupId
  {
    name: 'getDepTree',
    url: '/api/aam/v1/mgmt/groups/government/{@}'
  },
  // 获取指定组织树节点下组织（机构）或部门的信息 orgLevel
  {
    name: 'getDepTree2',
    url: '/api/aam/v1/mgmt/groups/government/{@}/groups'
  }
]
